<template>
  <div id="app" :class="$route.name">
    <iframe id="token-iframe" class="token-iframe" :src="iframeSrc" v-if="$store.state.env === 'development'"/>
    <mobile-menu/>
    <div class="d-flex column h-100 main-container" :class="{'mobile-menu': $store.state.mobileMenuActive}">
      <main-header v-if="$store.state.loggedIn"/>
      <el-container style="overflow: auto; flex-direction: column;" class="touch-scroll" v-loading="authLoading">
        <transition name="fade" mode="out-in" appear>
          <router-view v-if="!authLoading"></router-view>
        </transition>
        <footer class="footer-section hidden-sm-and-up">
          <div class="logo-footer">
            <img src="/static/coobo_logo.png" alt="">
          </div>
          <div class="copyright">
          </div>
        </footer>
      </el-container>
      <footer class="footer-section hidden-xs-only">
        <div class="logo-footer">
          <img src="/static/coobo_logo.png" alt="">
        </div>
        <div class="copyright">
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import MainHeader from "./components/main-header.vue"
  import MobileMenu from "./components/mobile-menu.vue"

  export default {
    name: 'App',
    data() {
      return {
        authLoading: true,
        tagsMap: {},
        demoTags: {},
        activeIndex: '1',
        activeIndex2: '1',
        iframeSrc: window.location.protocol + '//' + window.location.hostname + ':1337/login_token'
      }
    },
    mounted() {
      if(!localStorage.getItem('jwtReset1')) {
        localStorage.removeItem('jwt');
      }
      if(localStorage.getItem('jwt') && localStorage.getItem('jwtReset1')) {
        this.axios.get(this.$store.state.API_URL+'demo/user').then( (response) => {
          if(response.data) {
            this.$store.state.user = response.data;
            this.$store.state.loggedIn = true;
            this.authLoading = false;
            if (this.$route.name === "login") {
              this.$router.push("/my-library");
            }
          } else {
            Vue.axios.defaults.headers.common['Authorization'] = '';
            this.authLoading = false;
          }
        }).catch((error) => {
            this.$store.state.env !== "development" && localStorage.removeItem('jwt');
            this.authLoading = false;
            this.axios.defaults.headers.common['Authorization'] = '';
        });
      } else {
        this.authLoading = false;
      }
    },

    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    components: {
      MainHeader,
      MobileMenu
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue